import { X } from 'lucide-react'
import ProviderReviewsPanel from './ProviderReviewsPanel'
import type { ProviderReview } from '@lib/supabase/provider.service'

interface ProviderReviewsModalProps {
  open: boolean
  onClose: () => void
  providerName: string
  reviews: ProviderReview[]
  averageRating: number
  totalReviews: number
}

export default function ProviderReviewsModal({
  open,
  onClose,
  providerName,
  reviews,
  averageRating,
  totalReviews,
}: ProviderReviewsModalProps) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 p-0 sm:p-4">
      <div className="bg-card border border-border w-full sm:max-w-lg max-h-[90vh] flex flex-col shadow-xl rounded-t-2xl sm:rounded-2xl">
        <div className="flex items-start justify-between gap-3 p-5 border-b border-border shrink-0">
          <div>
            <h2 className="text-lg font-bold text-foreground">Patient Reviews</h2>
            <p className="text-sm text-muted-foreground mt-0.5">{providerName}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted text-muted-foreground"
            aria-label="Close reviews"
          >
            <X size={20} />
          </button>
        </div>
        <div className="overflow-y-auto p-5">
          <ProviderReviewsPanel
            reviews={reviews}
            averageRating={averageRating}
            totalReviews={totalReviews}
          />
        </div>
      </div>
    </div>
  )
}
